import { useState, useEffect } from 'react';
import { DeadlineDiscountPage } from './seller/DeadlineDiscountPage';
import { DesktopDeadlineDiscountPage } from './desktop/DesktopDeadlineDiscountPage';

export function ResponsiveDeadlineDiscountPage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <DeadlineDiscountPage /> : <DesktopDeadlineDiscountPage />;
}